import { either } from "fp-ts";
import { TTypeOfCodec } from "../../../../shared/src/codecs/codec";
import { literal } from "../../../../shared/src/codecs/types/literal";
import { union } from "../../../../shared/src/codecs/types/union";

export const CaseDocumentsSort = union([
    literal("alphabetical"),
    literal("newest"),
    literal("oldest"),
]);
export type TCaseDocumentsSort = TTypeOfCodec<typeof CaseDocumentsSort>;

export const CASE_DOCUMENTS_SORT_STORAGE_KEY = "case_documents_sort";

export const DefaultCaseDocumentsSort: TCaseDocumentsSort = "alphabetical";

export const decodeStoredCaseDocumentsSort = (stored: string | null): TCaseDocumentsSort | undefined => {
    if (stored === null) {
        return undefined;
    }
    const decoded = CaseDocumentsSort.decode(stored);
    return either.isRight(decoded) ? decoded.right : undefined;
};

export const resolveCaseDocumentsSort = (
    persistedSort: TCaseDocumentsSort | undefined,
): TCaseDocumentsSort =>
    persistedSort ?? DefaultCaseDocumentsSort;

export const getPersistedCaseDocumentsSort = (): TCaseDocumentsSort | undefined =>
    decodeStoredCaseDocumentsSort(localStorage.getItem(CASE_DOCUMENTS_SORT_STORAGE_KEY));

export const setPersistedCaseDocumentsSort = (sort: TCaseDocumentsSort): void =>
    localStorage.setItem(CASE_DOCUMENTS_SORT_STORAGE_KEY, sort);

export const getNextCaseDocumentsSort = (sort: TCaseDocumentsSort): TCaseDocumentsSort => {
    switch (sort) {
        case "alphabetical":
            return "newest";
        case "newest":
            return "oldest";
        case "oldest":
            return "alphabetical";
    }
};
